import React from "react";
import "../styles/hero.css";

const PHONE_NUMBER = "+36706276599";
const PHONE_TEL = `tel:${PHONE_NUMBER}`;

export default function Hero() {
  const handleCallClick = (e) => {
    e.preventDefault();

    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-17865564109/hgPsCO6_qeAbEM2_-8ZC",
        value: 1.0,
        currency: "HUF",
        event_callback: () => {
          window.location.href = PHONE_TEL;
        },
      });
    } else {
      window.location.href = PHONE_TEL;
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-overlay"></div>

      <div className="container hero-content">
        <h1 className="hero-title">
          Autókölcsönzés Szolnokon – gyorsan, egyszerűen, kedvező áron
        </h1>

        <h2 className="hero-subtitle">
          Bérelj megbízható, karbantartott autót akár azonnal, rugalmas
          átvétellel, rejtett költségek nélkül.
        </h2>

        <a href={PHONE_TEL} className="hero-cta" onClick={handleCallClick}>
          Hívás: +36 70 627 65 99
        </a>
      </div>
    </section>
  );
}
